/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetMarketplaceSettingsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetMarketplaceSettingsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetMarketplaceSettingsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetMarketplaceSettingsSecurity$outboundSchema: z.ZodMiniType<
  GetMarketplaceSettingsSecurity$Outbound,
  GetMarketplaceSettingsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getMarketplaceSettingsSecurityToJSON(
  getMarketplaceSettingsSecurity: GetMarketplaceSettingsSecurity,
): string {
  return JSON.stringify(
    GetMarketplaceSettingsSecurity$outboundSchema.parse(
      getMarketplaceSettingsSecurity,
    ),
  );
}

/** @internal */
export type GetMarketplaceSettingsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetMarketplaceSettingsRequest$outboundSchema: z.ZodMiniType<
  GetMarketplaceSettingsRequest$Outbound,
  GetMarketplaceSettingsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getMarketplaceSettingsRequestToJSON(
  getMarketplaceSettingsRequest: GetMarketplaceSettingsRequest,
): string {
  return JSON.stringify(
    GetMarketplaceSettingsRequest$outboundSchema.parse(
      getMarketplaceSettingsRequest,
    ),
  );
}
